import React from "react";
import "./Modal.css"; // We'll add styling separately

const CompanyApprovalModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <div className="modal-header">
          <h2>Account Under Review</h2>
        </div>
        <div className="modal-body">
          <p>
            Your <strong>company or college</strong> is not listed
            in our directory. Our admin team will review your request shortly and
            enable your account once the verification process is complete.
          </p>
          <p className="note">
            You’ll be notified as soon as your account becomes active. Thank you
            for your patience!
          </p>
        </div>
        <div className="modal-footer">
          <button className="modal-close-btn" onClick={onClose}>
            Got it
          </button>
        </div>
      </div>
    </div>
  );
};

export default CompanyApprovalModal;
